// tslint:disable: max-line-length
import { Component, OnInit } from '@angular/core';
import { RequestedDocument } from '@workflow/ecp-shared/model/requested.document.model';
import { RequestedDocumentApplicant } from '@workflow/ecp-shared/model/requested.document.applicant.model';
import { StatefulValue } from '@workflow/class/stateful-value.class';
import { ReviewBaseComponent } from '@workflow/ecp-workflow/dynamic-app/component/pages/review/review-base.component';
import { ReviewComponent } from '@workflow/ecp-workflow/dynamic-app/component/pages/review/review-resolver.component';
import { FieldInstance } from '@workflow/class/field.service';
/**
 * different type of field layout
 */
@ReviewComponent('requested-doc-review')
@Component({
  selector: 'ecp-requested-doc-review-card',
  templateUrl: './oao-requested-document-review.component.html'
})
export class RequestedDocumentReviewComponent extends ReviewBaseComponent implements OnInit {
  public requestedDocuments: RequestedDocument[] = [];
  public requestedDocumentApplicants: RequestedDocumentApplicant[] = [];
  /** ngOnInit */
  public ngOnInit(): void {
    const fields = this.card.fields.filter((t) => t.visible);
    this.buildRequestedDocApplicationReview(fields);
  }

  private buildRequestedDocApplicationReview(fields: FieldInstance[]): void {
    this.getOAOApplicants();

    if (!this.requestedDocumentApplicants || this.requestedDocumentApplicants.length === 0) {
      return;
    }
    fields.forEach((field) => {
      const data = field.data.valueString;
      const requestedDoc = (data && data.length > 0 ? JSON.parse(data) : {}) as RequestedDocument;
      requestedDoc.name = field.label;
      requestedDoc.id = field.id;
      requestedDoc.isRequired = field.required;
      switch (field.config.appliesTo) {
        case '0':
          for (let i = 0; i < this.requestedDocumentApplicants.length; i++) {
            requestedDoc.isDocSubmitted = requestedDoc.documents && requestedDoc.documents.filter((t) => t.uploadedBy === i).length > 0;
            if (this.requestedDocumentApplicants[i]) {
              this.requestedDocumentApplicants[i].requestedDocuments.push({ ...requestedDoc });
            }
          }
          break;
        case '1':
        case '':
        case undefined:
          requestedDoc.isDocSubmitted = requestedDoc.documents && requestedDoc.documents.filter((t) => t.uploadedBy === 0).length > 0;
          this.requestedDocumentApplicants[0].requestedDocuments.push({ ...requestedDoc });
          break;
        case '2': {
          if (this.requestedDocumentApplicants[1]) {
            requestedDoc.isDocSubmitted = requestedDoc.documents && requestedDoc.documents.filter((t) => t.uploadedBy === 1).length > 0;
            this.requestedDocumentApplicants[1].requestedDocuments.push({ ...requestedDoc });
          }
          break;
        }
      }
    });
  }

  // Get Applicant List
  public getOAOApplicants = (): void => {
    // 1. identify Membership Type 1. Personal = 1, 2. Youth = 2, 3. Business = 3,
    const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;

    switch (membershipTypeName && membershipTypeName.toLowerCase()) {
      case 'personal':
        this.buildRequestedDocWithApplicant('api:oaoMemberInformation/primaryApplicant');
        const hasCoApplicant = this.statefulService.wrap('api:oaoMemberInformation/hasCoApplicant').value as boolean;
        if (hasCoApplicant) {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          this.buildRequestedDocWithApplicant('api:oaoMemberInformation/coApplicant');
        }
        const additionalCoApplicantOption = this.statefulService.wrap('api:oaoMemberInformation/hasAdditionalCoApplicant').value as boolean;
        if (additionalCoApplicantOption) {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          this.buildRequestedDocWithApplicant('api:oaoMemberInformation/additionalCoApplicant');
        }
        break;
      case 'business':
        const responsiblePartyCount = this.statefulService.wrap(
          'api:oaoMemberInformation/businessInformation/responsiblePartyCount'
        ).valueStringOnly;
        if (Number.parseInt(responsiblePartyCount) > 0) {
          const responsibleParties = StatefulValue.arraySize('api:oaoMemberInformation/businessInformation/responsibleParties');
          for (let i = 0; i < responsibleParties; i++) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            this.buildRequestedDocWithApplicant(`api:oaoMemberInformation/businessInformation/responsibleParties/${i}`);
          }
        }
        break;
      default:
        break;
    }
  };

  // Get Applicant Name
  public buildRequestedDocWithApplicant = (apiPrimaryRoot: string): void => {
    const firstName = this.statefulService.wrap(`${apiPrimaryRoot}/firstName`).valueString;
    const lastName = this.statefulService.wrap(`${apiPrimaryRoot}/lastName`).valueString;
    const applicantName = `${firstName} ${lastName}`;
    if (applicantName) {
      const applicant = {} as RequestedDocumentApplicant;
      applicant.name = applicantName;
      applicant.requestedDocuments = [];
      this.requestedDocumentApplicants.push(applicant);
    }
  };
}
